module.exports = __webpack_public_path__ + "static/media/background-girl.2064831b.jpg";